import { clearObject } from './clearObject';

// Counts and stores the number of elements iterated over
// by item type. Exposes:
//    resetCurrentCount(): resets the current count
//    getCurrentItemTypeCurrentCount(): returns the current count after
//                                      the count has been reset
//    getCurrentItemTypeTotalCount(): returns the total item count
//    deleteItems(): deletes all stored items
export const itemTypeCounter = (() => {
  const items = {};

  const createType = (type, count = null) => {
    items[type] = {
      currentItemCount: count || 1,
      totalItemCount: count || 1,
    };
  };

  const addToCount = (type, count = null) => {
    if (!items[type]) {
      createType(type, count);
    } else {
      items[type].currentItemCount += count || 1;
      items[type].totalItemCount += count || 1;
    }
  };

  const getCurrentCount = (type) => {
    if (items[type]) {
      return items[type].currentItemCount;
    }
    return 0;
  };

  const getTotalCount = (type) => (items[type] ? items[type].totalItemCount : 0);

  // eslint-disable-next-line consistent-return
  const resetCurrentCount = (type) => {
    if (items[type]) {
      items[type].currentItemCount = 0;
    }
    return '';
  };

  return {
    addToCurrentItemTypeCount: (type, count) => addToCount(type, count),
    getCurrentItemTypeTotalCount: (type) => getTotalCount(type),
    getCurrentItemTypeCurrentCount: (type) => getCurrentCount(type),
    resetCurrentCount: (type) => resetCurrentCount(type),
    deleteItems: () => clearObject(items),
  };
})();
